import Home from './home_next';

export default Home;
